import { render, staticRenderFns } from "./FchTable.vue?vue&type=template&id=58eb3a28&scoped=true"
import script from "./FchTable.vue?vue&type=script&lang=js"
export * from "./FchTable.vue?vue&type=script&lang=js"
import style0 from "./FchTable.vue?vue&type=style&index=0&id=58eb3a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb3a28",
  null
  
)

export default component.exports